import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { trigger, transition, style, animate, state } from '@angular/animations';

interface OnboardingSlide {
    title: string;
    message: string;
    icon: string; // SVG icon name
}

@Component({
    selector: 'app-onboarding',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './onboarding.component.html',
    styleUrls: ['./onboarding.component.scss'],
    encapsulation: ViewEncapsulation.None,
    animations: [
        trigger('fadeSlide', [
            transition('void => *', [
                style({ opacity: 0, transform: 'translateY(20px)' }),
                animate('400ms cubic-bezier(0.4, 0.0, 0.2, 1)',
                    style({ opacity: 1, transform: 'translateY(0)' }))
            ]),
            transition('* => void', [
                animate('300ms ease-out',
                    style({ opacity: 0, transform: 'translateY(-10px)' }))
            ])
        ]),
        trigger('slideChange', [
            state('*', style({ opacity: 1 })),
            transition('* => *', [
                style({ opacity: 0 }),
                animate('350ms ease-in-out', style({ opacity: 1 }))
            ])
        ])
    ]
})
export class OnboardingComponent implements OnInit {
    currentSlide = 0;
    readonly totalSlides = 4;

    slides: OnboardingSlide[] = [
        {
            title: 'Suivi en temps réel',
            message: 'Suivi en temps réel de vos performances commerciales',
            icon: 'chart'
        },
        {
            title: 'Gestion clientèle',
            message: 'Gestion intelligente de votre clientèle',
            icon: 'users'
        },
        {
            title: 'Mode hors ligne',
            message: 'Accès mobile hors ligne pour le terrain',
            icon: 'offline'
        },
        {
            title: 'Géolocalisation',
            message: 'Géolocalisation et optimisation des tournées',
            icon: 'map'
        }
    ];

    constructor(private router: Router) { }

    ngOnInit(): void { }

    nextSlide(): void {
        if (this.currentSlide < this.totalSlides - 1) {
            this.currentSlide++;
        } else {
            this.goToDashboard();
        }
    }

    skipOnboarding(): void {
        this.goToDashboard();
    }

    goToSlide(index: number): void {
        if (index >= 0 && index < this.totalSlides) {
            this.currentSlide = index;
        }
    }

    private goToDashboard(): void {
        this.router.navigate(['/dashboard']);
    }

    get buttonText(): string {
        return this.currentSlide < this.totalSlides - 1 ? 'Suivant' : 'Commencer';
    }

    get progressPercentage(): number {
        return ((this.currentSlide + 1) / this.totalSlides) * 100;
    }
}
